// customisations for vee-validate

// import { required, confirmed, length, email } from "vee-validate/dist/rules";
// import { required } from "vee-validate/dist/rules";
import {
  extend,
  // required,
  localize /*setInteractionMode*/,
} from "vee-validate";
import it from "vee-validate/dist/locale/it.json";
import * as rules from "vee-validate/dist/rules";
import { toLocaleCurrency } from "@/utils/strings";
import moment from "moment";
moment.locale("it");
// Install VeeValidate rules and localization
Object.keys(rules).forEach((rule) => {
  extend(rule, rules[rule]);
});

localize("it", it);

// setInteractionMode("aggressive");

const operator_compare_date = {
  ">": function (a, b) {
    return moment(a, "DD/MM/YYYY") > moment(b, "DD/MM/YYYY");
  },
  "<": function (a, b) {
    return moment(a, "DD/MM/YYYY") < moment(b, "DD/MM/YYYY");
  },
  ">=": function (a, b) {
    return moment(a, "DD/MM/YYYY") >= moment(b, "DD/MM/YYYY");
  },
  "<=": function (a, b) {
    return moment(a, "DD/MM/YYYY") <= moment(b, "DD/MM/YYYY");
  },
  "=": function (a, b) {
    return moment(a, "DD/MM/YYYY") === moment(b, "DD/MM/YYYY");
  },
  "!=": function (a, b) {
    return moment(a, "DD/MM/YYYY") !== moment(b, "DD/MM/YYYY");
  },
  "<>": function (a, b) {
    return moment(a, "DD/MM/YYYY") !== moment(b, "DD/MM/YYYY");
  },
};

const operator_compare_number = {
  ">": function (a, b) {
    return a > b;
  },
  "<": function (a, b) {
    return a < b;
  },
  ">=": function (a, b) {
    return a >= b;
  },
  "<=": function (a, b) {
    return a <= b;
  },
  "=": function (a, b) {
    return a === b;
  },
  "!=": function (a, b) {
    return a != b;
  },
  "<>": function (a, b) {
    return a != b;
  },
};

// extend("required", {
//   ...required,
//   message: (field) => `Il campo ${field} è richiesto`,
// });

extend("between", {
  validate: (value, obj) => {
    // value must be > zero
    let v =
      typeof value === "string" ? parseFloat(value.replace(",", ".")) : value;
    // console.debug(`between: ${obj.min} < ${v} < ${obj.max}`);
    if (v >= obj.min && v <= obj.max) return true;
    return false;
  },
  // message: (field, args) => field + ` deve essere compreso tra ${[args["0"]]}`,
  message: (field, args) =>
    `Il campo ${field} deve essere compreso tra ${[args.min]} e ${[args.max]}`,
});

extend(
  "required_with",
  {
    validate(value, [otherValue]) {
      let required = !!value && !otherValue;
      // console.debug(
      //   `value: "${value}", otherValue: "${otherValue}", result: ${
      //     required ? "true" : "false"
      //   }`
      // );
      return !required;
      // let required = !value && target;
      // if (!required) {
      // return {
      //   valid: required,
      //   data: {
      //     required,
      //   },
      // };
      // }
    },
    // message: "Il campo {_field_} è collegato",
    message: (field) => `Il campo ${field} è obbligatorio`,
    // message: (field, args) => `Il campo è collegato a ${JSON.stringify(args)}`,
  },
  {
    hasTarget: true,
    computesRequired: true,
  }
);

// const dict = {
//   custom: {
//     email: {
//       required: "Your email is empty",
//     },
//     password: {
//       required: () => "Your password is empty",
//     },
//   },
// };

// localize("it", dict);

// extend("email", {
//   ...email,
//   message: "This field must be a valid email",
// });

// extend("confirmed", {
//   ...confirmed,
//   message: "This field confirmation does not match",
// });

// extend("length", {
//   ...length,
//   message: "This field must have 2 options",
// });

extend("required", {
  // ...required,
  message: (field) => `Il campo ${field} è richiesto`,
  validate(value) {
    const valid =
      (!Array.isArray(value) &&
        !["", null, undefined, false].includes(value)) ||
      (Array.isArray(value) && value.length > 0);
    return {
      required: true,
      valid: valid,
    };
  },
  computesRequired: true,
});
// Data esistente sul calendario (es. rifiuta 31/02/2026), nel formato del v-model
// (YYYY-MM-DD) o in quello digitato nel campo (DD/MM/YYYY).
extend("valid_date", {
  message: (field) => `Il campo ${field} non è una data valida`,
  validate: (value) =>
    moment(value, ["YYYY-MM-DD", "DD/MM/YYYY"], true).isValid(),
});
extend(
  "compare_date",
  {
    validate: (value, { otherValue, operator }) => {
      if (otherValue === "today") {
        otherValue = moment().format("DD/MM/YYYY");
      }
      return operator_compare_date[operator](value, otherValue);
    },
    params: ["otherValue", "operator"],
    message: (field, { otherValue, operator }) =>
      `${field} deve essere ${operator} ${otherValue}`,
  },
  {
    hasTarget: true,
    computesRequired: true,
  }
);
extend("compare_number", {
  validate: (value, { otherValue, operator }) => {
    let v =
      typeof value === "string"
        ? parseFloat(value.replace(",", "."))
        : parseFloat(value);
    let ov =
      typeof otherValue === "string"
        ? parseFloat(otherValue.replace(",", "."))
        : parseFloat(otherValue);
    console.debug("compare_number: ", v, ov);
    return operator_compare_number[operator](v, ov);
  },
  params: ["otherValue", "operator"],
  message: (field, { otherValue, operator }) =>
    `${field} deve essere ${operator} ${otherValue}`,
});

extend("compare_numbers", {
  validate: (value, { otherValues, operator }) => {
    let allValid = true;
    let v =
      typeof value === "string"
        ? parseFloat(value.replace(",", "."))
        : parseFloat(value);
    otherValues.forEach((otherValue) => {
      let ov =
        typeof otherValue === "string"
          ? parseFloat(otherValue.replace(",", "."))
          : parseFloat(otherValue);
      allValid &&= operator_compare_number[operator](v, ov);
      // console.debug("compare_numbers: ", v, ov);
    });
    return allValid;
  },
  params: ["otherValues", "operator"],
  message: (field, { otherValues, operator }) =>
    `${field} deve essere ${operator} ${otherValues.join(",")}`,
});

extend("between_number", {
    params: ["min", "max", "label"],
    validate: (value, { min, max }) => {
        const toNum = (x) => {
            if (x === null || x === undefined || x === "") return NaN;
            return typeof x === "string"
                ? parseFloat(x.replace(",", "."))
                : parseFloat(x);
        };

        const v = toNum(value);
        const mn = toNum(min);
        const mx = toNum(max);

        if (Number.isNaN(v) || Number.isNaN(mn) || Number.isNaN(mx)) return false;

        return v > mn && v <= mx; // or >= <= if you want inclusive
    },
    message: (field, { min, max, label }) => {
        return `${label ? label : field} deve essere maggiore di ${
            min === "0" ? "0,00 €" : toLocaleCurrency(min)
        } e minore o uguale a ${toLocaleCurrency(max)}`;
    },
});
